export enum WalletName {
  OneGate = 'OneGate',
  NeoLine = 'NeoLine',
  O3 = 'O3',
  Neon = 'Neon',
}
